import { TableCell, toCurrencyString, TableRow, Checkbox, CurrencyCode } from '@client/toolkit';
import { TableExpandableCell } from '../../components/table-expanable-cell';
import { BuildingOverdueInvoicesDto } from '@client/api';
import { useTranslation } from 'react-i18next';

export const BuildingRow = ({
  building,
  selectedRows,
  handleToggleSelect,
  handleKeyDownSelect,
  handleToggleExpand,
  handleKeyDownExpand,
  expandedRows,
}: {
  building: BuildingOverdueInvoicesDto;
  selectedRows: Set<string>;
  handleToggleSelect: (id: string) => void;
  handleKeyDownSelect: (e: React.KeyboardEvent<Element>, id: string) => void;
  handleToggleExpand: (id: string) => void;
  handleKeyDownExpand: (e: React.KeyboardEvent<Element>, id: string) => void;
  expandedRows: Set<string>;
}) => {
  const { t } = useTranslation('reporting');
  return (
    <TableRow className="bg-surface-elevated/40 border-b border-surface-elevated group hover:bg-surface-elevated">
      <TableCell className="px-2 py-2 align-top content-center">
        <Checkbox
          checked={selectedRows.has(building.buildingId)}
          onChange={() => handleToggleSelect(building.buildingId)}
          tabIndex={0}
          aria-label={`${t('table.select')} ${building.buildingName}`}
          onKeyDown={(e) => handleKeyDownSelect(e, building.buildingId)}
        />
      </TableCell>
      <TableExpandableCell
        label={building.buildingName}
        onClick={() => handleToggleExpand(building.buildingId)}
        onKeyDown={(e) => handleKeyDownExpand(e, building.buildingId)}
        ariaLabel={
          expandedRows.has(building.buildingId)
            ? `${t('table.selectedEntity')} ${building.buildingName}`
            : `${t('table.expandedEntity')} ${building.buildingName}`
        }
        isExpanded={expandedRows.has(building.buildingId)}
      />
      <TableCell className="px-2 py-2 align-top">
        {t('table.numberOfTenants', { count: building.tenantCount })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {toCurrencyString(building.currentPeriodOutstanding.value, '-', {
          currency: building.currentPeriodOutstanding.currency as CurrencyCode,
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {t('invoicesCount', { count: building.currentPeriodInvoiceCount })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">-</TableCell>
      <TableCell className="px-2 py-2 align-top">-</TableCell>
      <TableCell className="px-2 py-2 align-top">-</TableCell>
    </TableRow>
  );
};
